export function fromDiagnosticPackagesResult(data) {
  return Object.entries(data)
    .flatMap(([deviceId, packages]) =>
      Object.entries(packages).map(([diagPkgId, { encrypted, decrypted, creationTime, metadata }]) => ({
        deviceId,
        diagPkgId,
        encrypted,
        decrypted,
        userInfo: metadata,
        createdTime: creationTime
      }))
    )
    .sort((left, right) => new Date(right.createdTime).getTime() - new Date(left.createdTime).getTime());
}

export function fromDiagnosticPackageActionsResult({ instances = [] }) {
  return instances;
}
